// extracted by mini-css-extract-plugin
module.exports = {"tan":"#FEE5C0","black":"#020202","pink":"#FEAEBA","salmon":"#FB9985","blue":"#1F1CFB","darkblue":"#00006E","cream":"#FEBC48","lightblue":"#017CFF"};